import { ALBUM_FOLDER_PHOTOS_UPLOAD_MODE } from '../../constants/modals';
import useOpenModal from '../../hooks/useOpenModal';

/**
 * Simple hook to avoid the overhead of calling open modal logic for every upload.
 *
 * @returns {Function}
 */
const useAlbumFolderUpload = () => {
  const openModal = useOpenModal();

  const onUpload = ({ albumFolder, redirectOnUploadModeSetup, ...props }) => {
    openModal(ALBUM_FOLDER_PHOTOS_UPLOAD_MODE, {
      albumFolder,
      redirectOnUploadModeSetup,
      ...props,
    });
  };

  return onUpload;
};

export default useAlbumFolderUpload;
